import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ClientProvider } from '../providers/client.provider';
import { IdInterface } from '../data';
import { UseCaseWithParam } from './common/use.case.with.params';
import { Transaction } from '../transaction/transaction';

@Injectable()
export class CheckEmailUseCase implements UseCaseWithParam<string, Observable<Transaction<boolean>>> {
    constructor(private clientProvider: ClientProvider) {}

    bind(email: string, clientCode?: IdInterface): Observable<Transaction<boolean>> {
        return this.clientProvider.existByEmail(email, clientCode);
    }
}
